import React, {
  useCallback,
  useMemo,
  createContext,
  PropsWithChildren,
  useState,
} from 'react';

type AppContextType = {
  loadingProgress: Boolean;
  lastCreatedUserUid: string;
  setLastRegisteredUid: (uid: string) => void;
  toggleProgress: (value: boolean) => void;
};

export const AppContext = createContext<AppContextType>({
  loadingProgress: false,
  lastCreatedUserUid: '',
  setLastRegisteredUid: () => {},
  toggleProgress: () => {},
});

const AppContextProvider = (props: PropsWithChildren<{}>) => {
  const {children} = props;
  const [loadingProgress, setLoadingProgress] = useState(false);
  const [lastCreatedUserUid, setLastCreatedUserUid] = useState('');

  const toggleProgress = useCallback((value: boolean) => {
    setLoadingProgress(value);
  }, []);

  const setLastRegisteredUid = useCallback((uid: string) => {
    setLastCreatedUserUid(uid);
  }, []);

  const data = useMemo(() => {
    return {
      loadingProgress,
      lastCreatedUserUid,
      toggleProgress,
      setLastRegisteredUid,
    };
  }, [
    loadingProgress,
    toggleProgress,
    lastCreatedUserUid,
    setLastRegisteredUid,
  ]);

  return <AppContext.Provider value={data}>{children}</AppContext.Provider>;
};

export default AppContextProvider;
